jQuery(document).ready(function($) {
    $(".bloc_realisations").each(function(index) {
        var parent = $(this);
    });
});
